/** Preferred genders stored for the user (Uruguay product taxonomy). */
export type MetaPreferredGender = "Hombre" | "Mujer" | "Unisex";

/** Single-letter codes Meta Pixel advanced matching expects for `ge`. */
export type MetaPixelGenderCode = "m" | "f";

export function inferGenderFromPreferredGenders(
  preferredGenders: MetaPreferredGender[] | null | undefined,
): MetaPreferredGender | undefined {
  if (!preferredGenders) return undefined;
  return preferredGenders.includes("Hombre") &&
    !preferredGenders.includes("Mujer")
    ? "Hombre"
    : preferredGenders.includes("Mujer") && !preferredGenders.includes("Hombre")
      ? "Mujer"
      : undefined;
}

export function splitUserDisplayName(name: string | null | undefined): {
  firstName?: string;
  lastName?: string;
} {
  const trimmed = name?.trim();
  if (!trimmed) return {};
  const nameParts = trimmed.split(/\s+/);
  const firstName = nameParts[0];
  if (nameParts.length <= 1) {
    return { firstName };
  }
  return { firstName, lastName: nameParts.slice(1).join(" ") };
}

export function inferredGenderToMetaPixelGender(
  inferred: MetaPreferredGender | undefined,
): MetaPixelGenderCode | undefined {
  if (inferred === "Hombre") return "m";
  if (inferred === "Mujer") return "f";
  return undefined;
}

/**
 * Derives first name, last name, and Meta gender code from profile fields
 * (same rules as server-side Meta CAPI enrichment).
 */
export function getMetaUserAdvancedMatchingFields(input: {
  name?: string | null;
  preferredGenders?: MetaPreferredGender[] | null;
}): {
  firstName?: string;
  lastName?: string;
  gender?: MetaPixelGenderCode;
} {
  const { firstName, lastName } = splitUserDisplayName(input.name);
  const inferred = inferGenderFromPreferredGenders(input.preferredGenders);
  const gender = inferredGenderToMetaPixelGender(inferred);
  return {
    ...(firstName !== undefined ? { firstName } : {}),
    ...(lastName !== undefined ? { lastName } : {}),
    ...(gender !== undefined ? { gender } : {}),
  };
}
